// @ts-ignore
function createCookie(name, value, minutes) {
  var expires = '';
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
  }
  
  var secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax' + secure;
}

if (document.cookie.includes('formSubmitted=true')) {
  const form = document.querySelector('.contact-form__form');
  if (form) form.classList.add('form-submitted');
}

const contactUsForm = document.querySelector('.contact-form__form');
if (contactUsForm) {
  const zapierPath = /** @type {HTMLElement} */ (contactUsForm).dataset.zapierPath;
  const zapierID = /** @type {HTMLElement} */ (contactUsForm).dataset.zapierId;
  
  contactUsForm.addEventListener('submit', (e) => {
    
    // Always prevent default submission
    e.preventDefault();
    
    // Clear previous errors and success messages
    const errors = [];
    const errorContainer = contactUsForm.querySelector('.contact-form__errors');
    const errorList = contactUsForm.querySelector('.contact-form__error-list');
    const successContainer = contactUsForm.querySelector('.contact-form__success');
    
    contactUsForm.querySelectorAll('.contact-form__input').forEach(input => {
      input.classList.remove('error');
    });
    
    if (successContainer) {
      successContainer.style.display = 'none';
    }
    
    // Validate product
    const product = /** @type {HTMLSelectElement} */ (contactUsForm.querySelector('[name="contact[product]"]'));
    if (!product || !product.value) {
      errors.push('Product is required');
      if (product) product.classList.add('error');
    }
    
    // Validate reason
    const reason = /** @type {HTMLSelectElement} */ (contactUsForm.querySelector('[name="contact[reason]"]'));
    if (!reason || !reason.value) {
      errors.push('Reason is required');
      if (reason) reason.classList.add('error');
    }
    
    // Validate name
    const name = /** @type {HTMLInputElement} */ (contactUsForm.querySelector('[name="contact[name]"]'));
    if (!name || !name.value.trim()) {
      errors.push('Name is required');
      if (name) name.classList.add('error');
    }
    
    // Validate email
    const email = /** @type {HTMLInputElement} */ (contactUsForm.querySelector('[name="contact[email]"]'));
    if (!email || !email.value.trim()) {
      errors.push('Email is required');
      if (email) email.classList.add('error');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
      errors.push('Email is invalid');
      if (email) email.classList.add('error');
    }
    
    // If there are errors, show them and return
    if (errors.length > 0) {
      if (errorList) errorList.innerHTML = errors.map(error => `<li>${error}</li>`).join('');
      if (errorContainer) {
        errorContainer.style.display = 'block';
        errorContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    
    // No errors - hide error container and proceed with submission
    if (errorContainer) errorContainer.style.display = 'none';
    
    // Get submit button
    const submitButton = /** @type {HTMLButtonElement} */ (contactUsForm.querySelector('button[type="submit"]'));
    const originalButtonText = submitButton ? submitButton.innerHTML : '';
    
    // Check if Zapier is configured
    if (!zapierPath || !zapierID) {
      if (successContainer) successContainer.style.display = 'flex';
      createCookie("formSubmitted", "true", 5);
      return;
    }
    
    // Show loading state on button
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.innerHTML = '<span style="display: inline-flex; align-items: center; gap: 8px;"><svg style="animation: spin 1s linear infinite;" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10" opacity="0.75"/></svg>Sending...</span>';
    }
    
    // Create FormData and send to Zapier
    // @ts-ignore
    const formData = new FormData(contactUsForm);
    
    fetch('https://hooks.zapier.com/hooks/catch/'+zapierPath+'/'+zapierID+'/', {
      method: 'post',
      body: formData
    })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (submitButton) {
        submitButton.innerHTML = '<span style="display: inline-flex; align-items: center; gap: 8px;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>Sent Successfully!</span>';
      }
      
      if (successContainer) successContainer.style.display = 'flex';
      contactUsForm.classList.add('form-submitted');
      createCookie("formSubmitted", "true", 5);
      
      setTimeout(() => {
        contactUsForm.reset();
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.innerHTML = originalButtonText;
        }
      }, 2000);
    })
    .catch(() => {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.innerHTML = originalButtonText;
      }
      
      errors.push('Failed to submit form. Please try again.');
      if (errorList) errorList.innerHTML = errors.map(error => `<li>${error}</li>`).join('');
      if (errorContainer) errorContainer.style.display = 'block';
    });
  });
}